import { Typography } from "antd";
import "./RecruitmentQuestionRecommendListCard.scss";

function RecruitmentQuestionRecommendListCard({ list }) {
  const navigate = (id) => {
    window.open(
      `/recruitment_question_lists/${id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div
      className="recruitment-question-recommend-list-card"
      onClick={() => navigate(list.id)}
    >
      <div className="card-logo">
        <img src={list.image} alt="logo" />
      </div>
      <div className="card-info-wrapper">
        <div className="card-title">{list.title}</div>
        <div className="card-description">
          <Typography.Paragraph
            style={{ color: "grey", marginBottom: 0 }}
            ellipsis={{ rows: 2 }}
          >
            {list.description}
          </Typography.Paragraph>
        </div>
      </div>
    </div>
  );
}

export default RecruitmentQuestionRecommendListCard;
